export { default as HomePage } from "./InvestmentMemoDemo/InvestmentMemoDemo.Home";
